import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DrawingsPage } from '@/features/design/drawings-page';

const searchSchema = z.object({ drawing: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/design/drawings')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <DrawingsPage projectId={projectId} drawingId={search.drawing} />;
}
